<template>

<div class="d-flex align-items-center justify-content-between mb-1">

	<label class="col-form-label mr-2">{{ label }}</label>

	<div class="d-flex align-items-center">
		<field
			:params="params"
			v-model="localValue"
			v-on:input="$emit('input',$event)">
		</field>

		<button type="button" v-on:click="$emit('buttonClick')" class="btn-attached btn" :class="buttonClass">
			{{ buttonText }}
		</button>
	</div>
</div>

</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name: "FieldWithInlineButton",
	components: {
		Field
	},
	props: [
		"label",
		"buttonText",
		"params",
		"value",
		"buttonClass"
	],
	data() {
		return {
			localValue: null
		}
	},
	watch: {
		value() {
			this.localValue = this.value
		}
	},
	created() {
		this.localValue = this.value
	}
}
</script>